import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'

const DEFAULT_HEADERS: Record<string, string> = {
  'Cache-Control': 'no-cache',
}

@Injectable()
export class DefaultHttpHeadersInterceptor implements HttpInterceptor {
  intercept(
    httpRequest: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    const headersToAdd = Object.fromEntries(
      Object.entries(DEFAULT_HEADERS).filter(
        ([key]) => !httpRequest.headers.has(key),
      ),
    )

    if (Object.keys(headersToAdd).length === 0) {
      return next.handle(httpRequest)
    }

    return next.handle(
      httpRequest.clone({
        setHeaders: headersToAdd,
      }),
    )
  }
}
